<dx-scroll-view class="view-wrapper-scroll">
  <div class="view-wrapper">
    <dk-toolbar-dashboard
      titleText="Muhasebe Özet"
      [panelItems]="analyticsPanelItems"
      [selectedItems]="[5]"
      (selectionChanged)="selectionChange($event)"
    >
    </dk-toolbar-dashboard>

    <div class="cards grey">
      <dk-opportunities-ticker [data]="opportunities"></dk-opportunities-ticker>
      <dk-revenue-total-ticker [data]="sales"></dk-revenue-total-ticker>
      <dk-conversion-ticker></dk-conversion-ticker>
      <dk-leads-ticker></dk-leads-ticker>
    </div>

    <div class="cards">
      <dk-revenue-card [data]="sales"></dk-revenue-card>
      <dk-conversion-card [data]="opportunities"></dk-conversion-card>
      <dk-revenue-analysis-card
        [data]="salesByState"
      ></dk-revenue-analysis-card>
      <dk-revenue-snapshot-card
        [data]="salesByCategory"
      ></dk-revenue-snapshot-card>
    </div>
  </div>
</dx-scroll-view>
<dx-load-panel
  container=".view-wrapper"
  [position]="{ of: '.content' }"
  [visible]="isLoading"
  [showPane]="true"
></dx-load-panel>
